module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kbSOy"))).then(() => parcelRequire('2KbAe'));